import React from "react";
import Chair from "./Chair";
import Character from "./Character";
import Desk from "./Desk";
import Keyboard from "./Keyboard";
import Mouse from "./Mouse";
import Screens from "./Screens";

export default function DeskSection() {
  return (
    <>
      <Character />
      <Chair />
      <Desk />
      <Screens />
      <Mouse />
      <Keyboard />
    </>
  );
}
